<template>

  <TableCommon
    title="银行信息"
    :custome-config="() => vxeShowCustom('xTable3')"
  >
    <vxe-grid
      ref="xTable3"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      max-height="500"
      align="center"
      size="mini"
      :empty-render="{name: 'NotData'}"
      :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      :columns="gridOptions.columns"
      :data="gridOptions.data"
    />
  </TableCommon>

</template>

<script>
export default {
  props: {
    bank: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      id: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { title: '账户类型', field: 'accountType', minWidth: 200 },
          { title: '银行名称', field: 'ZZFLD000022', minWidth: 200 },
          { title: '银行账号', field: 'ZZFLD000023', minWidth: 200 },
          { title: '协议编号', field: 'ZZFLD00009J', minWidth: 200 },
          { title: '联系人', field: 'ZZFLD00009L', minWidth: 200 },
          { title: '电话', field: 'ZZFLD00009M', minWidth: 200 },
          { title: '可开具发票类型', field: 'ZZFLD00009R', minWidth: 200 }
        ],
        data: []
      }
    }
  },
  created() {
    this.gridOptions.data = this.bank
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/BankInfoCheck.vue